import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './authContext';

const LoginPage = () => {
  const [email, setEmail] = useState(''); // Email for ARGUS Auth Service
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const { login, user } = useAuth();
  const navigate = useNavigate();

  // Wenn bereits eingeloggt, zum Dashboard umleiten
  useEffect(() => {
    if (user) {
      navigate('/');
    }
  }, [user, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const result = await login(email, password);
      
      if (result.success) {
        navigate('/');
      } else {
        setError(result.message || 'Login fehlgeschlagen');
      }
    } catch (err) {
      setError(err.message || 'Ein Fehler ist aufgetreten');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      background: 'linear-gradient(to bottom, #fff5eb, #ffe5cc)'
    }}>
      <div style={{
        width: '100%',
        maxWidth: '400px',
        padding: '30px',
        backgroundColor: 'white',
        borderRadius: '10px',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
        border: '1px solid #e0e0e0'
      }}>
        <div style={{
          marginBottom: '30px',
          textAlign: 'center'
        }}>
          <h1 style={{
            fontSize: '3rem',
            fontWeight: '700',
            letterSpacing: '2px',
            color: '#e65c00',
            marginBottom: '10px'
          }}>ARGUS</h1>
          <div style={{
            height: '4px',
            width: '60px',
            backgroundColor: '#ff8c2a',
            margin: '0 auto',
            borderRadius: '4px',
            marginBottom: '20px'
          }}></div>
          <p style={{
            color: '#6b7280'
          }}>Hermes</p>
          {process.env.REACT_APP_ENVIRONMENT && (
            <span style={{
              display: 'inline-block',
              fontSize: '0.7rem',
              fontWeight: 700,
              padding: '3px 12px',
              borderRadius: '4px',
              backgroundColor: process.env.REACT_APP_ENVIRONMENT === 'DEV' ? '#4299E1' : '#F6AD55',
              color: 'white',
              letterSpacing: '1px',
              marginTop: '8px',
            }}>
              {process.env.REACT_APP_ENVIRONMENT}
            </span>
          )}
        </div>
        
        {error && (
          <div style={{
            padding: '16px',
            marginBottom: '20px',
            borderRadius: '8px',
            backgroundColor: '#fff0eb',
            border: '1px solid #ffd2c2',
            color: '#c53200',
            fontSize: '14px'
          }}>
            {error}
          </div>
        )}
        
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '20px' }}>
            <label
              htmlFor="email"
              style={{
                display: 'block',
                marginBottom: '8px',
                fontSize: '14px',
                fontWeight: '500',
                color: '#374151'
              }}
            >
              E-Mail
            </label>
            <input
              id="email"
              type="email"
              autoComplete="email"
              style={{
                width: '100%',
                padding: '12px',
                border: '1px solid #d1d5db',
                borderRadius: '6px',
                backgroundColor: 'white',
                color: '#374151'
              }}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={false}
              required
            />
          </div>
          
          <div style={{ marginBottom: '24px' }}>
            <label 
              htmlFor="password"
              style={{
                display: 'block',
                marginBottom: '8px',
                fontSize: '14px',
                fontWeight: '500',
                color: '#374151'
              }}
            >
              Passwort
            </label>
            <input
              id="password"
              type="password"
              autoComplete="current-password"
              style={{
                width: '100%',
                padding: '12px',
                border: '1px solid #d1d5db',
                borderRadius: '6px',
              }}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          
          <button
            type="submit"
            style={{
              width: '100%',
              padding: '12px',
              backgroundColor: loading ? '#ffa64d' : '#ff8000',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              fontWeight: '500',
              cursor: loading ? 'not-allowed' : 'pointer'
            }}
            disabled={loading}
          >
            {loading ? 'Wird angemeldet...' : 'Anmelden'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
